import { connect } from "react-redux";

import actions from "../../actions";
import ScheduleRightRowChiba from "../../components/list/ScheduleRightRowChiba";

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateItem: (data, handleSuccess, handleCancel) =>
      dispatch(actions.schedule_chiba.updateItem(data, handleSuccess, handleCancel)),
    showAlert: (title, messages, okClickHandler) => dispatch(actions.app.showAlert(title, messages, okClickHandler)),
    hideAlert: () => dispatch(actions.app.hideAlert()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleRightRowChiba);
